import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { toJS } from 'mobx';
import { cast, getParent, types, getRoot } from 'mobx-state-tree';
import moment from 'moment';
import { api } from 'src/api';
import { createAsync } from 'src/utils/asyncModel';
const getAllResidenciesRelatedToSpecificBuildingAsync = createAsync(body => {
  return async function getAllResidenciesRelatedToSpecificBuilding(options) {
    const resp = await api.Residencies.getAllResidenciesRelatedToSpecificBuilding(body, options);
    return resp;
  };
});
const getAllResidenciesRelatedToSpecificBuildingV2Async = createAsync(body => {
  return async function getAllResidenciesRelatedToSpecificBuildingV2(options) {
    const resp = await api.Residencies.getAllResidenciesRelatedToSpecificBuildingV2(body, options);
    return resp;
  };
});
const getAllResidenciesRelatedToSpecificBuildingAggregateAsync = createAsync(body => {
  return async function getAllResidenciesRelatedToSpecificBuildingAggregate(options) {
    const resp = await api.Residencies.getAggregateResidencies(body, options);
    const _getParent = getParent(this),
      account = _getParent.account,
      residencies = _getParent.residencies;
    account.setProfilesFullNamesAfterFetch(resp);
    residencies.setResidenciesAfterLoad(resp);
    return resp;
  };
});
const searchResidenciesAggregateAsync = createAsync(body => {
  return async function searchResidenciesAggregate(options) {
    const resp = await api.Residencies.searchResidenciesAggregate(body, options);
    const _getRoot = getRoot(this),
      homeDashboardStore = _getRoot.homeDashboardStore;
    if (resp !== null && resp !== void 0 && resp.isSuccessful) {
      var _homeDashboardStore$g, _homeDashboardStore$g2, _resp$response;
      (_homeDashboardStore$g = homeDashboardStore.getCurrentCompany) === null || _homeDashboardStore$g === void 0 || (_homeDashboardStore$g = _homeDashboardStore$g.companyResidentsTabOptions) === null || _homeDashboardStore$g === void 0 || _homeDashboardStore$g.updateModel(resp === null || resp === void 0 ? void 0 : resp.response);
      (_homeDashboardStore$g2 = homeDashboardStore.getCurrentCompany) === null || _homeDashboardStore$g2 === void 0 || _homeDashboardStore$g2.setCompanyResidents(resp === null || resp === void 0 || (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.buildingResidency);
    }
    return resp;
  };
});
const getResidencyOverviewByResidencyIdAsync = createAsync(body => {
  return async function getResidencyOverviewByResidencyId(options) {
    const resp = await api.Residencies.getResidencyOverviewByResidencyId(body, options);
    const _getParent2 = getParent(this),
      residencies = _getParent2.residencies;
    residencies.setResidencyOverviewByResidencyIdAfterLoad(resp);
    return resp;
  };
});
const createNewResidencyAsync = createAsync(body => {
  return async function createNewResidency(options) {
    const resp = await api.Residencies.createNewResidency(body, options);
    return resp;
  };
});
const getPropertyResidentsAddendumsAsync = createAsync(body => {
  return async function getPropertyResidentsAddendums(options) {
    const resp = await api.Residencies.getPropertyResidentsAddendums(body, options);
    return resp;
  };
});
const getPropertyResidentsAddendumsV2Async = createAsync(body => {
  return async function getPropertyResidentsAddendumsV2(options) {
    const resp = await api.Residencies.getPropertyResidentsAddendumsV2(body, options);
    return resp;
  };
});
const getResidencyMoveOutDateAsync = createAsync(body => {
  return async function getResidencyMoveOutDate(options) {
    const resp = await api.Residencies.getResidencyMoveOutDate(body, options);
    this.setMoveOutDetails(resp);
    return resp;
  };
});
const updateResidencyMoveOutDateAsync = createAsync(body => {
  return async function updateResidencyMoveOutDate(options) {
    const resp = await api.Residencies.updateResidencyMoveOutDate(body, options);
    this.setFSEBatchIds(resp);
    return resp;
  };
});
const getResidencyLeaseDetailsAsync = createAsync(body => {
  return async function getResidencyLeaseDetails(options) {
    const resp = await api.Residencies.getResidencyLeaseDetails(body, options);
    this.setLeaseDetails(resp.response);
    return resp;
  };
});
const updateResidencyNotesAsync = createAsync(body => {
  return async function updateResidencyNotes(options) {
    const resp = await api.Residencies.updateResidencyNotes(body, options);
    return resp;
  };
});
const getResidencyOccupancyAsync = createAsync(body => {
  return async function getResidencyOccupancy(options) {
    const resp = await api.Residencies.getResidencyOccupancy(body, options);
    this.setOccupancyDetails(resp.response);
    return resp;
  };
});
const updateResidencyOccupancyAsync = createAsync(body => {
  return async function updateResidencyOccupancy(options) {
    const resp = await api.Residencies.updateResidencyOccupancy(body, options);
    this.setOccupancyDetails({
      occupancy: body.occupancy
    });
    return resp;
  };
});
const batchUpdateResidencyOccupancyAsync = createAsync(body => {
  return async function batchUpdateResidencyOccupancy(options) {
    const resp = await api.Residencies.batchUpdateResidencyOccupancy(body, options);
    return resp;
  };
});
const getResidencyNotesAsync = createAsync(body => {
  return async function getResidencyNotes(options) {
    const resp = await api.Residencies.getResidencyNotes(body, options);
    return resp;
  };
});
const getResidencyBillingSettingsAsync = createAsync(body => {
  return async function getResidencyBillingSettings(options) {
    const resp = await api.Residencies.getResidencyBillingSettings(body, options, getParent(this).account.featureFlagsStore.getIsBillAutomationEnabled || getParent(this).account.featureFlagsStore.getIsBillingTemplatesEnabled);
    this.setBillingSettingsDetails(resp);
    return resp;
  };
});
const updateResidencyBillingSettingsAsync = createAsync(body => {
  return async function updateResidencyBillingSettings(options) {
    const resp = await api.Residencies.updateResidencyBillingSettings(body, options, getParent(this).account.featureFlagsStore.getIsBillAutomationEnabled || getParent(this).account.featureFlagsStore.getIsBillingTemplatesEnabled);
    return resp;
  };
});
const updateResidencyLeaseDetailsAsync = createAsync(body => {
  return async function updateResidencyLeaseDetails(options) {
    const resp = await api.Residencies.updateResidencyLeaseDetails(body, options);
    return resp;
  };
});
const getResidencyPaperCorrespondenceSettingAsync = createAsync(body => {
  return async function getResidencyPaperCorrespondenceSetting(options) {
    const resp = await api.Residencies.getResidencyPaperCorrespondenceSetting(body, options);
    return resp;
  };
});
const putResidencyPaperCorrespondenceSettingAsync = createAsync(body => {
  return async function putResidencyPaperCorrespondenceSetting(options) {
    const resp = await api.Residencies.updateResidencyPaperCorrespondenceSetting(body, options);
    return resp;
  };
});
const resendPaperInvitationAsync = createAsync(body => {
  return async function resendPaperInvitation(options) {
    const resp = await api.Residencies.resendPaperInvitation(body, options);
    return resp;
  };
});
const resendPaperStatementAsync = createAsync(body => {
  return async function resendPaperStatement(options) {
    const resp = await api.Residencies.resendPaperStatement(body, options);
    return resp;
  };
});
const getResidencyAddressesAsync = createAsync(body => {
  return async function getResidencyAddresses(options) {
    const resp = await api.Residencies.getResidencyAddresses(body, options);
    return resp;
  };
});
const addResidencyAddressAsync = createAsync(body => {
  return async function addResidencyAddress(options) {
    const resp = await api.Residencies.addResidencyAddress(body, options);
    return resp;
  };
});
const updateResidencyAddressAsync = createAsync(body => {
  return async function updateResidencyAddress(options) {
    const resp = await api.Residencies.updateResidencyAddress(body, options);
    return resp;
  };
});
const deleteResidencyAddressAsync = createAsync(body => {
  return async function deleteResidencyAddress(options) {
    const resp = await api.Residencies.deleteResidencyAddress(body, options);
    return resp;
  };
});
const updateResidencyAddressStatusAsync = createAsync(body => {
  return async function updateResidencyAddressStatus(options) {
    const resp = await api.Residencies.updateResidencyAddressStatus(body, options);
    return resp;
  };
});
const setAllCustomPrimaryAddressesToSecondaryAsync = createAsync(body => {
  return async function setAllCustomPrimaryAddressesToSecondary(options) {
    const resp = await api.Residencies.setAllCustomPrimaryAddressesToSecondary(body, options);
    return resp;
  };
});
const batchUpdateBillingSettingsAsync = createAsync(body => {
  return async function batchUpdateBillingSettings(options) {
    const resp = await api.Residencies.batchUpdateBillingSettings(body, options);
    return resp;
  };
});
const LeaseDetails = types.model({
  leaseAddendumFileIds: types.maybeNull(types.array(types.string)),
  leaseStartDateOnly: types.maybeNull(types.string)
});
const LeaseDetailsInitialData = {
  leaseAddendumFileIds: null,
  leaseStartDateOnly: null
};
const OccupancyDetails = types.model({
  occupancy: types.number
});
const OccupancyDetailsInitialData = {
  occupancy: 1
};
const BillingSettingsUtility = types.model({
  utilityId: types.string,
  utilityTypeId: types.string,
  propertyUtilityId: types.string,
  utilityTypeName: types.string,
  utilityProviderName: types.union(types.string, types.undefined),
  utilityCap: types.maybeNull(types.number)
});
const BillingSettingsDetails = types.model({
  residencyId: types.string,
  billingType: types.string,
  billingStartDateOnly: types.maybeNull(types.string),
  residencyUtilities: types.array(BillingSettingsUtility),
  residencyUtilityOptOuts: types.array(BillingSettingsUtility),
  statementCap: types.maybeNull(types.number)
});
const BillingSettingsDetailsInitialData = {
  residencyId: '',
  billingType: 'Bill',
  billingStartDateOnly: '',
  residencyUtilities: [],
  residencyUtilityOptOuts: []
};
const BillingSettingsResultDataUtility = types.model({
  utilityId: types.string,
  utilityType: types.string,
  utilityCap: types.maybeNull(types.number)
});
const BillingSettingsResultData = types.model({
  billingType: types.string,
  billingStartDateOnly: types.maybeNull(types.string),
  moveInDateOnly: types.maybeNull(types.string),
  utilities: types.array(BillingSettingsResultDataUtility),
  statementCap: types.maybeNull(types.number)
});
const BillingSettingsResultDataInitialData = {
  billingType: 'Bill',
  billingStartDateOnly: '',
  utilities: []
};
const DataGrid = types.model({
  occupancyModal: types.boolean,
  enrollmentModal: types.boolean
});
const ResidencyOverview = types.model({
  billingStartDateOnly: types.maybeNull(types.string),
  effectiveConvergentBilling: types.optional(types.boolean, false),
  leaseEndDateOnly: types.maybeNull(types.string),
  leaseStartDateOnly: types.maybeNull(types.string),
  occupancy: types.number,
  residencyId: types.maybeNull(types.string),
  unitName: types.string
});
const defaultResidencyOverview = {
  billingStartDateOnly: '',
  effectiveConvergentBilling: false,
  leaseEndDateOnly: '',
  leaseStartDateOnly: '',
  occupancy: 0,
  residencyId: null,
  unitName: ''
};
const Residency = types.model({
  fullName: types.string,
  unitName: types.string,
  utilityIds: types.optional(types.array(types.string), [])
});
const AddressDetails = types.model({
  addressId: types.string,
  city: types.string,
  isValid: types.boolean,
  secondary: types.string,
  state: types.string,
  street: types.string,
  zip: types.string
});
const CustomAddresses = types.model({
  isPrimary: types.maybeNull(types.boolean),
  addressId: types.string,
  details: types.maybeNull(AddressDetails)
});
const ResidenciesStore = types.model('ResidenciesStore', {
  activeTab: types.optional(types.string, 'residencies'),
  fseBatchIdValue: types.maybeNull(types.string),
  getResidencyNotesAsync,
  createNewResidencyAsync,
  addResidencyAddressAsync,
  resendPaperStatementAsync,
  updateResidencyNotesAsync,
  getResidencyOccupancyAsync,
  resendPaperInvitationAsync,
  getResidencyAddressesAsync,
  updateResidencyAddressAsync,
  deleteResidencyAddressAsync,
  getResidencyMoveOutDateAsync,
  getResidencyLeaseDetailsAsync,
  updateResidencyOccupancyAsync,
  updateResidencyMoveOutDateAsync,
  batchUpdateBillingSettingsAsync,
  getResidencyBillingSettingsAsync,
  updateResidencyLeaseDetailsAsync,
  updateResidencyAddressStatusAsync,
  batchUpdateResidencyOccupancyAsync,
  getPropertyResidentsAddendumsAsync,
  updateResidencyBillingSettingsAsync,
  getPropertyResidentsAddendumsV2Async,
  getResidencyOverviewByResidencyIdAsync,
  setAllCustomPrimaryAddressesToSecondaryAsync,
  getAllResidenciesRelatedToSpecificBuildingAsync,
  getAllResidenciesRelatedToSpecificBuildingV2Async,
  getAllResidenciesRelatedToSpecificBuildingAggregateAsync,
  searchResidenciesAggregateAsync,
  getResidencyPaperCorrespondenceSettingAsync,
  putResidencyPaperCorrespondenceSettingAsync,
  leaseDetails: types.optional(LeaseDetails, LeaseDetailsInitialData),
  customAddresses: types.optional(types.array(CustomAddresses), []),
  datePickermoveOutDateValue: types.maybeNull(types.Date),
  moveOutDateOnlyValue: types.maybeNull(types.string),
  dataGrid: types.optional(DataGrid, {
    occupancyModal: false,
    enrollmentModal: false
  }),
  occupancyDetails: types.optional(OccupancyDetails, OccupancyDetailsInitialData),
  billingSettingsDetails: types.optional(BillingSettingsDetails, BillingSettingsDetailsInitialData),
  billingSettingsResultData: types.optional(BillingSettingsResultData, BillingSettingsResultDataInitialData),
  postFseAutomaticallyValue: types.optional(types.boolean, false),
  refreshFlagValue: types.optional(types.boolean, false),
  residenciesIdsByBuildingValue: types.array(types.string),
  residenciesValue: types.map(Residency),
  residencyOverviewValue: types.optional(ResidencyOverview, _objectSpread({}, defaultResidencyOverview)),
  residencyUtilitiesValue: types.optional(types.array(BillingSettingsUtility), []),
  excludedUtilityIdsValue: types.map(types.array(types.string))
}).views(store => ({
  get datePickermoveOutDate() {
    return store.datePickermoveOutDateValue;
  },
  get fseBatchId() {
    return store.fseBatchIdValue;
  },
  get refreshFlag() {
    return store.refreshFlagValue;
  },
  get moveOutDateOnly() {
    return store.moveOutDateOnlyValue;
  },
  get postFseAutomatically() {
    return store.postFseAutomaticallyValue;
  },
  get residencyOverview() {
    return toJS(store.residencyOverviewValue);
  },
  get residencyUtilities() {
    return store.residencyUtilitiesValue;
  },
  get residencies() {
    return toJS(store.residenciesValue);
  },
  get residenciesIdsByBuilding() {
    return toJS(store.residenciesIdsByBuildingValue);
  },
  get excludedUtilityIds() {
    return toJS(store.excludedUtilityIdsValue);
  }
})).actions(store => ({
  addNewCustomAddress(data) {
    try {
      if (data.isPrimary) {
        const fIndex = store.customAddresses.findIndex(i => !!i.isPrimary);
        if (fIndex > -1) store.customAddresses[fIndex].isPrimary = false;
      }
      store.customAddresses.push(data);
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  setCustomAddress(data) {
    try {
      if (data.isPrimary) {
        const fIndex = store.customAddresses.findIndex(i => !!i.isPrimary);
        if (fIndex > -1) store.customAddresses[fIndex].isPrimary = false;
      }
      const cIndex = store.customAddresses.findIndex(i => i.addressId === data.addressId);
      if (cIndex > -1) {
        store.customAddresses[cIndex].details = data.details;
        store.customAddresses[cIndex].addressId = data.addressId;
        store.customAddresses[cIndex].isPrimary = data.isPrimary;
      }
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  changePrimaryPropertyAddress(data) {
    try {
      const fIndex = store.customAddresses.findIndex(i => !!i.isPrimary);
      if (fIndex > -1) store.customAddresses[fIndex].isPrimary = false;
      const cIndex = store.customAddresses.findIndex(i => i.addressId === data.addressId);
      if (cIndex > -1) store.customAddresses[cIndex].isPrimary = true;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  makesPropertyAddressAsPrimary() {
    try {
      const cIndex = store.customAddresses.findIndex(i => !!i.isPrimary);
      if (cIndex > -1) store.customAddresses[cIndex].isPrimary = false;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  removePropertyAddresses(id) {
    try {
      const cIndex = store.customAddresses.findIndex(i => i.addressId === id);
      store.customAddresses.splice(cIndex, 1);
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  setFSEBatchIds(resp) {
    try {
      const fseBatchId = resp.response.fseBatchId;
      if (fseBatchId) {
        store.fseBatchIdValue = fseBatchId;
      }
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  showOccupancyUpdateModal() {
    try {
      store.dataGrid.occupancyModal = true;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  showEnrollmentModal() {
    try {
      store.dataGrid.enrollmentModal = true;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  resetDataGrid() {
    try {
      store.dataGrid.occupancyModal = false;
      store.dataGrid.enrollmentModal = false;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  saveActiveTab(tab) {
    try {
      store.activeTab = tab;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  setLeaseDetails(data) {
    try {
      store.leaseDetails = data;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  setDatePickermoveOutDate(date) {
    try {
      store.datePickermoveOutDateValue = date;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  setMoveOutDetails(data) {
    try {
      store.datePickermoveOutDateValue = data.response.moveOutDateOnly ? moment(data.response.moveOutDateOnly).toDate() : null;
      store.moveOutDateOnlyValue = data.response.moveOutDateOnly;
      store.postFseAutomaticallyValue = data.response.postFseAutomatically;
      const _getParent3 = getParent(store),
        fse = _getParent3.fse;
      fse === null || fse === void 0 || fse.setFSEBillModalToggle(data.response.moveOutDateOnly === null ? true : data.response.postFseAutomatically);
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  resetLeaseDetails() {
    try {
      store.leaseDetails = {
        leaseStartDateOnly: null,
        leaseAddendumFileIds: cast([])
      };
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  setOccupancyDetails(data) {
    try {
      store.occupancyDetails = data;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  toggleRefreshFlag(flag) {
    try {
      // Always apply when true so grids refresh after actions (e.g. FSE submit) even if activeTab was stale.
      store.refreshFlagValue = !!flag;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  setBillingSettingsDetails(resp) {
    const data = resp.response;
    try {
      store.billingSettingsResultData.utilities = cast([]);
      store.billingSettingsDetails = data;
      store.residencyUtilitiesValue = data.residencyUtilities;
      store.billingSettingsResultData.billingStartDateOnly = data.billingStartDateOnly;
      store.billingSettingsResultData.moveInDateOnly = data.moveInDateOnly;
      data.residencyUtilities.map(i => {
        store.billingSettingsResultData.utilities.push({
          utilityId: i.utilityId,
          utilityType: 'RatioBilling',
          utilityCap: i.utilityCap
        });
      });
      data.residencyUtilityOptOuts.map(i => {
        store.billingSettingsResultData.utilities.push({
          utilityId: i.utilityId,
          utilityType: 'Optout',
          utilityCap: i.utilityCap
        });
      });
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  setBillingSettingsStatementCap(value) {
    try {
      store.billingSettingsDetails.statementCap = value;
      store.billingSettingsResultData.statementCap = value;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  changeBillingSettingsbillingStartDateResultData(date) {
    try {
      store.billingSettingsResultData.billingStartDateOnly = date;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  changeBillingSettingsUtilitiesResultData(id, type) {
    try {
      const currentUtilityIndex = store.billingSettingsResultData.utilities.findIndex(item => item.utilityId === id);
      store.billingSettingsResultData.utilities[currentUtilityIndex].utilityType = type;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  changeUtilitiesCapResultData(id, value) {
    try {
      const currentUtilityIndex = store.billingSettingsResultData.utilities.findIndex(item => item.utilityId === id);
      store.billingSettingsResultData.utilities[currentUtilityIndex].utilityCap = value;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  changeStatementCapResultData(value) {
    try {
      store.billingSettingsResultData.statementCap = value;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  setResidencyOverviewByResidencyIdAfterLoad(resp) {
    try {
      const _resp$response2 = resp.response,
        billingStartDateOnly = _resp$response2.billingStartDateOnly,
        effectiveConvergentBilling = _resp$response2.effectiveConvergentBilling,
        leaseEndDateOnly = _resp$response2.leaseEndDateOnly,
        leaseStartDateOnly = _resp$response2.leaseStartDateOnly,
        occupancy = _resp$response2.occupancy,
        residencyId = _resp$response2.residencyId,
        unitName = _resp$response2.unitName;
      store.residencyOverviewValue = {
        billingStartDateOnly,
        effectiveConvergentBilling,
        leaseEndDateOnly,
        leaseStartDateOnly,
        occupancy,
        residencyId,
        unitName
      };
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  setResidenciesAfterLoad(resp) {
    try {
      store.residenciesIdsByBuildingValue = resp.response.buildingResidency.map(item => item.residencyId).filter(item => item);
      store.residenciesValue = resp.response.buildingResidency.reduce((acc, item) => {
        if (item.residencyId) acc[item.residencyId] = {
          fullName: item.fullname,
          unitName: item.unitName,
          utilityIds: item.unitData.utilityIds
        };
        return acc;
      }, {});
      store.excludedUtilityIdsValue = resp.response.buildingResidency.reduce((acc, item) => {
        if (item.unitId) {
          acc[item.unitId] = item.unitData.utilityIds;
        }
        return acc;
      }, {});
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  }
}));
export const residencies = types.optional(ResidenciesStore, {});